import { TRoomsParams } from 'common/types/floor-params.type';
import { LaminateInputs } from '../../../types';
import { getFormData } from './get-form-data';
import { getRoomIdsWithSameInputParams } from './get-room-ids-with-same-input-params';

export const setSelectedRoomIdIfNeeded = ({
  calculatedRooms,
  defaultValues,
  isAreaSelected,
  setSelectedRoomId,
}: {
  calculatedRooms: TRoomsParams[];
  defaultValues: LaminateInputs;
  isAreaSelected: boolean;
  setSelectedRoomId: (valOrUpdater: string | ((currVal: string) => string)) => void;
}) => {
  if (calculatedRooms.length > 0) {
    const formData = getFormData({ data: defaultValues, isRoomArea: isAreaSelected });
    const roomIdsWithSameInputParams = getRoomIdsWithSameInputParams({
      dataInRooms: calculatedRooms,
      inputParams: formData,
    });
    if (roomIdsWithSameInputParams.length > 0) {
      setSelectedRoomId(roomIdsWithSameInputParams[0]);
    }
  }
};
